export default __webpack_public_path__ + "static/media/joe.89f4e46c.png";